<template>
<form class="form-horizontal" @submit.prevent="submit">
  <fieldset v-for="(group, legend) in form.config">
    <legend>{{ legend }}</legend>
    <form-group v-for="(field, index) in group"
                :key="index"
                :label="field.label"
                :label-col="2"
                :control-col="10"
                :error="errors[field.name]">
      <text-input v-model="form.fields[field.name]"></text-input>
    </form-group>
  </fieldset>

  <button class="btn btn-primary" :disabled="submitting">
    <template v-if="submitting">Zapisywanie</template>
    <template v-else>Zapisz</template>
  </button>
</form>
</template>

<script>
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'

export default {
  name: 'FormData',
  props: {
    url: { type: String, required: true },
    method: { type: String, default: 'POST' },
    form: { type: Object, required: true }
  },
  data () {
    return {
      submitting: false,
      errors: {}
    }
  },
  components: {
    FormGroup,
    TextInput
  },
  methods: {
    submit () {
      this.submitting = true
      let fields = { ...this.form.fields }
      Object.keys(fields).forEach(k => {
        if (k.includes('@')) {
          delete fields[k]
        }
      })
      this
        .$http[this.normalizedMethod](this.url, fields)
        .then(this.handleSuccess, this.handleError)
        .then(() => {
          this.submitting = false
        })
    },
    handleSuccess () {
      this.errors = {}
      this.$emit('success')
    },
    handleError ({ status, body }) {
      if (status === 400) {
        this.errors = this.normalizeErrors(body.violations)
      }
    },
    normalizeErrors (errors) {
      let newErrors = {}
      errors.forEach(e => {
        newErrors[e.propertyPath] = e.message
      })
      return newErrors
    }
  },
  computed: {
    normalizedMethod () {
      return this.method.toLowerCase()
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormData.vue?6c23fa5a